import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-pro-wa-radar-chart',
	templateUrl:'./WaRadarChartProPage.html',
	styles: [],
	styleUrls:['./WaRadarChartProPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaRadarChartProPage
{
	mdContent_430 = `\`\`\`java
import com.jwebmp.webawesomepro.components.chart.WaRadarChart;
\`\`\``;
	mdContent_431 = `\`\`\`java
new WaRadarChart<>()
\`\`\``;
}
